import { render, staticRenderFns } from "./DislikeIcon.vue?vue&type=template&id=073203bb"
import script from "./DislikeIcon.vue?vue&type=script&lang=ts"
export * from "./DislikeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports